import { useState, useEffect } from "@wordpress/element";
import Stepper from "vino/core/Stepper";
import { useDispatch } from "react-redux";
import queryString from "query-string";
import {
	getEvent,
	getEventSlots,
	resetEventBooking,
} from "store/vino/eventBookingSlice";
import { settings } from "settings";
import EventInformation from "./steps/EventInformation";
import BillingAddress from "./steps/BillingAddress";
import Payment from "./steps/Payment";

const steps = [
	{
		id: 1,
		name: "Event Information",
	},
	{
		id: 2,
		name: "Billing",
	},
	{
		id: 3,
		name: "Payment",
	},
];

const EventBooking = () => {
	const dispatch = useDispatch();
	const [activeStep, setActiveStep] = useState(0);
	const parsed = queryString.parse(location.search);
	const { eventId } = parsed;

	useEffect(() => {
		if (eventId) {
			dispatch(getEvent(eventId));
			dispatch(getEventSlots(eventId));
		} else {
			window.location.href = settings.urls.wineEvents;
		}
	}, [dispatch, eventId]);

	const handleChangeActiveStep = (newActiveStep) => {
		if (activeStep > newActiveStep) {
			setActiveStep(newActiveStep);
		}
	};

	const handleNext = () => {
		setActiveStep(activeStep + 1);
	};

	const handleBack = () => {
		setActiveStep(activeStep - 1);
	};

	return (
		<div className="flex flex-col w-full mt-10">
			<div className="flex justify-center w-full">
				<div className="w-full max-w-3xl">
					<Stepper
						classes={{ root: "bg-transparent" }}
						activeStep={activeStep}
						steps={steps}
						onClick={handleChangeActiveStep}
					/>
				</div>
			</div>
			<div className="flex justify-center w-full">
				<div className="w-full overflow-auto max-w-2xl">
					{activeStep === 0 && <EventInformation onNext={handleNext} />}
					{activeStep === 1 && (
						<BillingAddress onNext={handleNext} onBack={handleBack} />
					)}
					{activeStep === 2 && <Payment onBack={handleBack} />}
				</div>
			</div>
		</div>
	);
};

export default EventBooking;
